// @ts-nocheck
import { Navigate } from "react-router-dom"
import { NotificationsClient } from "@/components/notifications/NotificationsClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function NotificationsPage() {
  const { supabaseUser } = useAuth()
  if (!supabaseUser) return <Navigate to="/auth/login" replace />
  return <div className="container-narrow py-4"><NotificationsClient userId={supabaseUser.id} /></div>
}